import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { CommonDescription } from "../CommonDescription/CommonDescription";
import { Icon, IconType } from "@/components/formatters/MXPIcon";
export interface IconTextNoodle {
  iconMachineName?: IconType;
  header?: string;
  description?: string;
  link?: {
    label: string;
    destination: string;
  };
  isIconVisible?: boolean;
  isDarkTheme?: boolean;
}
export const IconTextNoodle = t0 => {
  const $ = _c(25);
  const {
    iconMachineName,
    header,
    description,
    link,
    isIconVisible: t1,
    isDarkTheme
  } = t0;
  const isIconVisible = t1 === undefined ? true : t1;
  const textColor = isDarkTheme ? "text-white" : "text-gray-m9";
  let t2;
  if ($[0] !== iconMachineName || $[1] !== isIconVisible) {
    t2 = isIconVisible && iconMachineName && <div className="bg-yellow-m10 text-gray-m9 w-[66px] h-[66px] flex justify-center items-center text-center mb-6"><Icon type={iconMachineName} size={48} /></div>;
    $[0] = iconMachineName;
    $[1] = isIconVisible;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `hidden min-sm:block text-xl font-bold not-italic mt-5 mb-2 ${textColor}`;
  let t4;
  if ($[3] !== header || $[4] !== t3) {
    t4 = <h3 className={t3}>{header}</h3>;
    $[3] = header;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== header || $[7] !== isDarkTheme || $[8] !== link || $[9] !== textColor) {
    t5 = link ? <Link className={`flex min-sm:hidden items-center gap-4 text-xl mt-5 mb-2 font-bold not-italic no-underline hover:underline ${textColor}`} href={link.destination || "#"}>{header}<span className="flex items-center"><Icon type="t2-icon--open-caret-right-dark-16px" size={18} fillColor={isDarkTheme ? "#FFFFFF" : "#353A40"} /></span></Link> : <h3 className={`min-sm:hidden text-xl font-bold not-italic mt-5 mb-2 ${textColor}`}>{header}</h3>;
    $[6] = header;
    $[7] = isDarkTheme;
    $[8] = link;
    $[9] = textColor;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex flex-col">{t2}{t4}{t5}</div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = `mb-3 text-base md:text-lg not-italic font-normal leading-relaxed no-underline grow ${textColor}`;
  let t8;
  if ($[15] !== description || $[16] !== t7) {
    t8 = <CommonDescription description={description} className={t7} />;
    $[15] = description;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isDarkTheme || $[19] !== link) {
    t9 = link && <Link className={`hidden min-sm:flex items-center gap-2.5 text-xl font-bold no-underline tracking-wide ${isDarkTheme ? "text-white" : "text-blue-trmb"}`} href={link?.destination || "#"} tabIndex={0}>{link.label}<Icon type="t2-icon--open-caret-right-dark-16px" size={16} fillColor={isDarkTheme ? "#FFFFFF" : "#353A40"} /></Link>;
    $[18] = isDarkTheme;
    $[19] = link;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t6 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className="flex flex-col max-sm:p-0">{t6}{t8}{t9}</div>;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};